import styled from 'styled-components';
import { Content } from '../../../theme/layout';

export const Container = styled(Content)``;
